import type { RootState } from "store/types";

// `security` (src/reducers/security.js) is a new slice unwound at the selector boundary
// (Phase 0b's per-slice-on-demand pattern, following store/selectors/filters.ts). Only the one
// field RoundHistoryPerGame/GamesRoundHistory need is exposed here — don't speculatively add more.
export function selectSessionId(state: RootState): string | undefined {
  return state.security.get("sessionId");
}
